// extracted by mini-css-extract-plugin
export default {"hideTooltip":"q--z","fadeIn":"r--z","delay":"s--z","recommendedSizeTooltip":"t--z"};